var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c("div", { staticClass: "container" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                on: { click: _vm.toggleViewBy },
              },
              [_vm._v("View by: " + _vm._s(_vm.ViewBy))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary",
                on: { click: _vm.toggleFilter },
              },
              [_vm._v("Filter: " + _vm._s(_vm.Filter))]
            ),
            _vm._v(" "),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _vm.ViewBy === "Foundation"
              ? _c(
                  "table",
                  { staticClass: "table table-hover" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._l(_vm.FoundationsView, function (f) {
                      return _c("tbody", { key: f.AlternativeId }, [
                        _c("tr", [
                          _c("td", [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: _vm.url_AlternativeDashboardPage(
                                      f.Id
                                    ),
                                    expression:
                                      "url_AlternativeDashboardPage(f.Id)",
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(f.Name))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            _vm._l(_vm.getDependents(f), function (d) {
                              return _c("span", { key: d.Id }, [
                                _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "sanitizedHref",
                                        rawName: "v-sanitizedHref",
                                        value: _vm.url_AlternativeDashboardPage(
                                          d.Id
                                        ),
                                        expression:
                                          "url_AlternativeDashboardPage(d.Id)",
                                      },
                                    ],
                                  },
                                  [_vm._v(_vm._s(d.Name))]
                                ),
                                _vm._v(", \n                        "),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.ViewBy === "Dependent"
              ? _c(
                  "table",
                  { staticClass: "table table-hover" },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._l(_vm.DependentsView, function (d) {
                      return _c("tbody", { key: d.AlternativeId }, [
                        _c("tr", [
                          _c("td", [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: _vm.url_AlternativeDashboardPage(
                                      d.Id
                                    ),
                                    expression:
                                      "url_AlternativeDashboardPage(d.Id)",
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(d.Name))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            _vm._l(_vm.getFoundations(d), function (f) {
                              return _c("span", { key: f.Id }, [
                                _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "sanitizedHref",
                                        rawName: "v-sanitizedHref",
                                        value: _vm.url_AlternativeDashboardPage(
                                          f.Id
                                        ),
                                        expression:
                                          "url_AlternativeDashboardPage(f.Id)",
                                      },
                                    ],
                                  },
                                  [_vm._v(_vm._s(f.Name))]
                                ),
                                _vm._v(",\n                        "),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "container",
        staticStyle: { "margin-top": "80px", "padding-top": "40px" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6" }, [
            _c(
              "h1",
              {
                staticStyle: {
                  "font-size": "2em",
                  "font-weight": "300",
                  color: "#33475b",
                  margin: "0",
                },
              },
              [_vm._v("Dependencies")]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-6 text-right" }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Foundation")]),
        _vm._v(" "),
        _c("th", [_vm._v("Dependents")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Dependent")]),
        _vm._v(" "),
        _c("th", [_vm._v("Foundations")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "100px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }